import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormTextField from "../form/text";
import { url } from "../../config";
import successToast from "../toast/successToast";
import errorToast from "../toast/errorToast";
import axios from "axios";

const ResetPasswordModal = ({ isOpen = false, onClose = () => {}, id }) => {
  const initialValues = {
    id: id,
    password: "",
  };

  const validationSchema = Yup.object().shape({
    password: Yup.string().required("Required"),
  });

  const handleSubmit = (values) => {
    console.log(values, "values");
    axios
      .post(`${url}/ffadmin/reset-password`, values)
      .then((response) => {
        successToast(response.message);
        console.log(response, "response");
        onClose();
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center"
          onClick={handleOverlayClick}
        >
          <div
            className="bg-white rounded-lg shadow-lg max-w-lg w-full md:p-10 p-4 relative"
            onClick={(e) => e.stopPropagation()}
          >
            <h1 className="text-center text-lg md:text-xl font-semibold text-gray-800">
              Are you sure you want to reset your password?
            </h1>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize={true}
            >
              <Form>
                <div className="my-4 mt-10">
                  <FormTextField
                    name={"password"}
                    label={"password"}
                    placeholder={`Enter your password`}
                  />
                </div>
                <div className="flex justify-between gap-5">
                  <button
                    type="button"
                    onClick={onClose}
                    className="border border-primary text-primary text-base font-medium py-2 w-1/2 max-w-[14rem] rounded-md"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="bg-primary text-white text-base font-medium py-2 w-1/2 max-w-[12rem] rounded-md"
                  >
                    Submit
                  </button>
                </div>
              </Form>
            </Formik>
          </div>
        </div>
      )}
    </>
  );
};

export default ResetPasswordModal;
